import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscriber } from 'rxjs/Subscriber';
import { PartGroup } from './partgroup.model';
import { PagerService } from '../../shared/services/pager.service';
import { PartGroupService } from '../../shared/services/partgroup.service';

@Component({
    selector: 'app-partgroup',
    templateUrl: './partgroup.component.html',
    styleUrls: ['./partgroup.component.css']
})
export class PartGroupComponent implements OnInit {
    partCategoryId: number;
    productlineId: number;
    partGroups: PartGroup[];
    pagedItems: any = [];
    isDataLoaded = false;

    constructor(private _partGroupService: PartGroupService, private _route: ActivatedRoute) { }

    getPartGroups() {
        this._partGroupService.getPartGroupByCategoryId(this.productlineId, this.partCategoryId).subscribe(res => {
            this.partGroups = res;
            this.isDataLoaded = true;
        });
    }
    setPageData(data: any) {
        this.pagedItems.data = this.partGroups.slice(data.startIndex, data.endIndex);
        this.pagedItems.routeName = 'partgroup';
    }
    ngOnInit() {
        this._route.params.subscribe(
            (params: Params) => {
                this.partCategoryId = +params['pcid'];
                this.productlineId = +params['plid'];
                this.getPartGroups();
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/partgroup/partgroup.component.ts